export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11048.45e0966b.jpg";